import React from 'react';
import AppStoreButton from './AppStoreButton';
import { ASSETS } from './assetPaths';
import './SiteNavigation.css';

export default function SiteNavigation({ isLearn }) {
  return (
    <nav className="hero__topbar" aria-label="Main navigation">
      <a className="wordmark" href="/" aria-label="Ayro home">
        <img src={ASSETS.banner} alt="Ayro Breathwork" />
      </a>
      <div className="site-tabs">
        <a href="/" aria-current={!isLearn ? 'page' : undefined}>Home</a>
        <a href="/learn/" aria-current={isLearn ? 'page' : undefined}>Learn</a>
      </div>
      <AppStoreButton appleLogo text="Download" />
    </nav>
  );
}
